import { WinnerConveyor } from './components/WinnerConveyor/WinnerConveyor';
import { useConveyorCapacity } from './hooks/useConveyorCapacity';
import { useWinners } from './hooks/useWinners';
import styles from './WinnersBanner.module.scss';

export function WinnersBanner() {
  const { tiles, loading } = useWinners();
  const { viewportRef, containerWidth, minSlots } = useConveyorCapacity();

  const show = !loading && tiles.length >= minSlots;

  return (
    <div
      ref={viewportRef}
      className={`${styles.banner}${show ? '' : ` ${styles.collapsed}`}`}
      data-testid="winners-banner"
    >
      {show && <WinnerConveyor containerWidth={containerWidth} tiles={tiles} />}
    </div>
  );
}
